var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnpinnedImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 3.33335V7.50002C11.6665 8.43335 11.9748 9.30002 12.4998 10H7.49984C8.0415 9.28335 8.33317 8.41669 8.33317 7.50002V3.33335H11.6665ZM14.1665 1.66669H5.83317C5.37484 1.66669 4.99984 2.04169 4.99984 2.50002C4.99984 2.95835 5.37484 3.33335 5.83317 3.33335H6.6665V7.50002C6.6665 8.88335 5.54984 10 4.1665 10V11.6667H9.1415V17.5L9.97484 18.3334L10.8082 17.5V11.6667H15.8332V10C14.4498 10 13.3332 8.88335 13.3332 7.50002V3.33335H14.1665C14.6248 3.33335 14.9998 2.95835 14.9998 2.50002C14.9998 2.04169 14.6248 1.66669 14.1665 1.66669Z",
    fill: "#004895"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpinnedImg);
export default __webpack_public_path__ + "static/media/Unpinned_Img.b009a6559c21ac2cc3093d525a9b75c5.svg";
export { ForwardRef as ReactComponent };